"use strict";
/* eslint-disable no-bitwise */var zeroFiller=function(r){for(var t="";t.length<r;)t+="0";return t},isChildBitwise=function(r,t){var e=4294967296,r=parseInt(r,10),t=parseInt(t,10),i=(r&t).toString(2),i=zeroFiller(32-i.length)+i,r=(Math.floor(r/e)&Math.floor(t/e)).toString(2),t=zeroFiller(32-r.length)+r;return!!parseInt(t+i,2)};
/** Делает побитовое & с возможностью использования больших чисел (до 64 бит),
 * чем при обычном побитовом &
 *
 * @param bitsum - первое число
 * @param child - второе число
 */module.exports=isChildBitwise;
